<template>
  <div class="pl-md-5 pr-md-5 pl-4 pr-4 ticket">
    <b-card class="mt-2" v-if="ticket">
      <b-card-header>
        <h4 class="mt-2 NotoSansGeorgian-Bold">ვიზიტი ოფისში</h4>
        <p class="mt-2 NotoSansGeorgian-Regular address">თქვენ დაჯავშნეთ რიგის ნომერი<br/>
          თბილისი, ვაჟა-ფშაველას 3
        </p>
        <p class="mt-2 NotoSansGeorgian-Regular client">{{ ticket.appointment.customers[0].name }}</p>
      </b-card-header>
      <b-card-body>
        <div class="info">
          <div class="mb-1">
            <img src="../assets/img/time.svg">
            <span class="ml-2 details NotoSansGeorgian-Regular">{{ ticket.time }}</span>
          </div>
          <div class="mb-1">
            <img src="../assets/img/calendar.svg">
            <span class="ml-2 details NotoSansGeorgian-Regular">{{ ticket.date }}</span>
          </div>
          <div class="mb-1">
            <img src="../assets/img/info.svg">
            <span class="ml-2 details NotoSansGeorgian-Regular">{{ ticket.appointment.services[0].name }}</span>
          </div>
        </div>
        <div class="pl-3 pr-3">
          <div class="dotted-line"></div>
        </div>
        <div class="info d-flex" v-if="code">
          <!-- <vue-qr  :correctLevel="3"
                   :dotScale="0.8"
                   :text="code.toString()"
                   :size="80"
                   :margin="5">
 
           </vue-qr>-->
          <qrcode-vue :value="code.toString()" :size="80"></qrcode-vue>
          <div class="ml-3 p-3">
            <div class="NotoSansGeorgian-Bold details">
              ჯავშანი
            </div>
            <div class="NotoSansGeorgian-Bold details tkt-number font-weight-bold">
              N {{ ticket.appointment.id }}
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <div class="d-flex justify-content-center pt-4">
      <b-button variant="outline-primary" class="font-weight-bold" @click="deleteAppointment">ვიზიტის გაუქმება
      </b-button>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: "Ticket",
  components: {
    QrcodeVue
  },
  data() {
    return {
      id: this.$route.params.tId,
      ticket: null,
      code: ''
    }
  },
  mounted() {
    this.$http.get("/booking/GetTicket/" + this.id)
        .then((r) => {
          this.ticket = r.data;
          this.code = r.data.appointment.id;
          console.log(r)
        })
        .catch((e) => {
          console.error(e)
        })
  },
  methods: {
    deleteAppointment() {
      this.$http.delete(`/booking/DeleteReservation/${this.id}/${this.$route.params.id}`).then(() => {
        this.$bvModal.msgBoxOk('ჯავშანი გაუქმებულია', {
          title: 'თანხმობა',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'primary',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
            .then(() => {
              location.replace('https://ardi.ge')
            })
            .catch(() => {
              // An error occurred
            })

      })
          .catch((e) => {console.log()
            this.$bvModal.msgBoxOk(e.response.data.Message, {
              title: 'error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'error',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
                .then(() => {
                  location.replace('https://ardi.ge')
                })
                .catch(() => {
                  // An error occurred
                })
           // alert(e.response.data.Message)
            })
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 10px !important;
  box-shadow: 0 0 3px #899BB1;
  border: 0 !important;
  position: relative;
}

.card:before {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /*background-image: linear-gradient(90deg, #fff, #a8b0b9);*/
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(212, 223, 237, .8) 86%, rgba(204, 215, 226, .7) 100%);
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  content: '';
  top: 68%;
  left: -10px;
}

.card:after {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /*background-image: linear-gradient(90deg, #fff, #a8b0b9);*/
  background-image: linear-gradient(-90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(212, 223, 237, .8) 86%, rgba(204, 215, 226, .7) 100%);
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  content: '';
  top: 68%;
  right: -19px;
}

.card-body {
  padding: 0 !important;
}

.info {
  padding: .75rem 1.25rem !important;
  color: #231F20 !important;
}

.card-header {
  background-color: #00A987 !important;
  border-radius: 10px 10px 0 0 !important;
  color: #ffffff;
}

h4 {
  font-size: 18px;
}

.address {
  font-size: 14px;
}

.client {
  font-size: 12px;
}

.details {
  font-size: 14px;
}

.dotted-line {
  width: 100%;
  border-top: 100px dashed #707070;
  border-width: thin;
  border-spacing: 7px;
}

.tkt-number {
  color: #00A987;
}

@media only screen and (min-width: 1300px) {
  .ticket {
    padding-left: 5rem !important;
    padding-right: 5rem !important;
  }
}

@media only screen and (min-width: 1500px) {
  .ticket {
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }
}

@media only screen and (min-width: 1800px) {
  .ticket {
    padding-left: 11rem !important;
    padding-right: 11rem !important;
  }
}
</style>